import React from "react";
import { Link } from "react-router-dom";
import * as CountryCode from '../../Config/CountryCode.js';

class Emailormobileenter extends React.Component {
  
  render() {
    this.state = this.props.data.state;

    if (this.state.isValidEmail || this.state.isValidMobile) {
      var fenable = false;
      if (this.state.isValidEmail && this.state.isValidMobile) {
         fenable = true;
      } else {
         fenable = false;
      }
    } else {
      var fenable = true;
    }
    
    return (
     <>
  
  <div className="temp4 pass-tab">
    <hr />
    <hr />
    <div className="temp4-InnerRound50">
      <div className="temp4-InnerRound1">
        <div className="temp4-InnerRound2" />
      </div>
    </div>
    <div className="temp4-InnerRound51">
      <div className="temp4-InnerRound3" />
    </div>
    <div className="temp4-InnerRound52">
      <div className="temp4-InnerRound3" />
    </div>
  </div>
  <header>
    <div className="mainNav">
      <div onClick={() => {this.props.data.backbutton();}}className="docubayBack white pl-8">
        <img src="img/svg/back.svg" alt="DocuBay" /> Reset password
      </div>
      <div className="topQuestion">
    {/*<img src="img/svg/help.svg" alt="help" />*/}
  </div>
    </div>
  </header>
  <main>
    <section className="mb-0">
      <div className="homeBanner">
        <div className="innerBanner mb-0">
          <div className="title-reset forgetpass">
            <h1>
              Reset <span className="red">password</span>
            </h1>
            <div className="reset">
              Please enter your email address or mobile number to request a
              password reset.
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style={{ paddingBottom: 25 }}>
      <div className="temp31">
        <div className="temp31Inner">
          <div className={
                    this.state.fields.fld_mobile && this.state.fields.fld_mobile.length>0 ? "formField disable-fild" : "formField"
                  } >
                <input
                  type="text"
                  name="fld_email"
                  placeholder="Enter email address"
                  className={
                    this.state.errors.isValidEmailerror ? "error-border" : null
                  }
                  value={this.state.fields.fld_email}
                  onChange={this.props.data.handleChange}
                  disabled={this.state.fields.fld_mobile && this.state.fields.fld_mobile.length>0 ? true:false}
                  autoComplete="off"
                  autoComplete="new-password"
                />
                {this.state.errors.isValidEmailerror ? (
                  <div className="error">
                    <img
                      src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                      alt="DocuBay"
                    />
                    <p>{this.state.msg.alreadyRegiter} </p>
                  </div>
                ) : null}
              </div>
          <div className="temp1Or"> OR </div>
          <div className={this.state.errors.isValidMobileerror ? " formField error-border data":"formField data"} ref={this.emailInput} >
              
                <select name="country_code" className="selectTel" onChange={this.props.data.handleChange}   disabled={this.state.fields.fld_email && this.state.fields.fld_email.length>0?true:false}>
                {
                  CountryCode.Countrycode.map(CoutryData =>{
                    return (  <option key={CoutryData.name} value={CoutryData.dial_code} >{CoutryData.dial_code}</option>)
                  })
                }
                </select>
                <input
                  name="fld_mobile"
                  type="tel"
                  className="inputTel"   
                  placeholder="Enter mobile number"
                  value={this.state.fields.fld_mobile}
                  onChange={this.props.data.handleChange}
                  disabled={this.state.fields.fld_email && this.state.fields.fld_email.length>0?true:false}
                  minLength="6" 
                  maxLength="15"
                  autoComplete="off"
                  autoComplete="new-password"
                  required/>
                
              </div>
              {this.state.errors.isValidMobileerror ? (
                  <div className="error error-verifyotp">
                    <img
                      src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                      alt="DocuBay"
                    />
                    <p>{this.state.msg.alreadyRegiter} </p>
                  </div>
                ) : null}
              <div className="formField mt-24 mb-24">
                <button
                  type="button"
                  onClick={() => {
                    this.props.data.checkuser();
                  }}
                  disabled={fenable}
                  className={
                    fenable ? "btn-black" : "btn-red"
                  }
                >
                  Proceed
                </button>
              </div>
          <div className="temp1Login">
            Remember your password?{" "}
            <Link to="/createaccount" className="whiteLogin">
              Log in
            </Link>
          </div>
        </div>
      </div>
    </section>
  </main>
</>

    );
  }
}
export default Emailormobileenter;
